import { createSelector } from 'reselect';
import _ from 'lodash';
import { getModules } from './core';

function createSlugToObjectMap(items) {
  return _.reduce(
    items,
    (acc, item) => {
      acc[item.slug] = item;
      return acc;
    },
    {}
  );
}

const moduleSlugToObjectMapSelector = createSelector(
  getModules,
  createSlugToObjectMap
);

const introPageSelector = state => state.content.introPages;
const introPageSlugToObjectMapSelector = createSelector(
  introPageSelector,
  createSlugToObjectMap
);

const lessonSelector = state => state.content.lessons;
const lessonSlugToObjectMapSelector = createSelector(
  lessonSelector,
  createSlugToObjectMap
);

const slugMapSelector = createSelector(
  moduleSlugToObjectMapSelector,
  introPageSlugToObjectMapSelector,
  lessonSlugToObjectMapSelector,
  (modulesMap, introPagesMap, lessonsMap) => ({
    modules: modulesMap,
    introPages: introPagesMap,
    lessons: lessonsMap
  })
);

export default slugMapSelector;
